import { perfMetrics, perfSection } from '@/content/site'

import { Reveal } from './shared/Reveal'
import { SectionHeading } from './shared/SectionHeading'

export function PerformanceSection() {
  return (
    <section id="performance" className="relative py-20 md:py-28">
      <div className="shell">
        <SectionHeading eyebrow={perfSection.eyebrow} title={perfSection.title} />

        <div className="grid grid-cols-2 gap-3 lg:grid-cols-4">
          {perfMetrics.map((m, i) => (
            <Reveal key={m.label} i={i} className="h-full">
              <article className="glass glass-rim flex h-full flex-col p-5 md:p-6">
                <p className="font-sans text-[1.6rem] md:text-[2rem] font-semibold leading-none tracking-tight text-ink tabular-nums">
                  {m.value}
                </p>
                <p className="mt-3 font-paragraph text-[0.85rem] text-ink-dim">{m.label}</p>
                <p className="mt-1 font-mono text-[0.56rem] uppercase tracking-wider text-ink-mute">
                  {m.sub}
                </p>
              </article>
            </Reveal>
          ))}
        </div>

        <Reveal i={4}>
          <p className="micro mt-6">{perfSection.note}</p>
        </Reveal>
      </div>
    </section>
  )
}
